import Plot from 'react-plotly.js';
import * as Plotly from 'plotly.js';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { abbreviateNumber } from '../../../utils/utils';
import './index.scss';

export default function SummaryTable({
  barWidthValue,
  barData,
  axisKeys,
  height,
  type
}: {
  barWidthValue: number;
  // barData: BarChartDetails;
  barData: any;
  axisKeys: { key: string; alias: string; color: string }[];
  height: number;
  // eslint-disable-next-line react/require-default-props
  type?: string;
}) {
  const yAxis: string[] = [];
  // const xAxis: {label : string; value: number}[] = [];
  const xAxis: number[] | any = [];
  const txt: string[] = [];
  axisKeys.slice().forEach((axisData) => {
    xAxis.push(barData[axisData.key]);
    yAxis.push(axisData.key);
    txt.push(`${axisData.alias}`);
  });
  const tableRowHeight = height / axisKeys?.length || 30;

  return (
    <div className='bar-chart-container'>
      <div className='table-row' style={{ minHeight: '36px' }}>
        <div className='table-cell' style={{ paddingLeft: '24px' }}>Abs</div>
        <div className='table-cell' style={{ marginLeft: '24px', paddingLeft: '20px' }}>%</div>
      </div>
      {xAxis.map((e, i) => (
        <div key={i} className='table-row' style={{ minHeight: `${tableRowHeight}px` }}>
          <div className='table-cell summary-table-cell'>
            <span>
              {e[0] ? abbreviateNumber('', e[0]) : 0}
            </span>
          </div>
          <div className='table-cell'>
            <div
              className={`flex-div ${e[1] > 0 ? 'positive-div' : 'negative-div'
                }`}
              style={{ fontSize: '12px' }}
            >
              {e[1] > 0 ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
              {e[1] ? e[1].toFixed(1) : 0}%
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}